import { PaginationState } from "@tanstack/react-table";
import { PaginatedFilter } from "../types/axios.types";
import { createContext, useContext } from "react";

export const DataTableContext = createContext<Partial<{
    filters: PaginatedFilter;
    setFilters: (key: string, value: string) => void;
    globalFilter: string;
    setGlobalFilter: (filter: string) => void;
    pagination: PaginationState;
    setPagination: (pagination: PaginationState) => void;
    setPage: (page: number) => void;
  }>>({});

export const useDataTableContext = () => {
    return useContext(DataTableContext);
}
